import { fg } from '@atlassian/jira-feature-gating';

const SwimlanesChangeboarding = {
	get(): boolean {
		return fg('board_harmonisation_m3_swimlanes_changeboarding');
	},
};

export default SwimlanesChangeboarding;
